<div id="viewAssertionsModalDialog" class="modal fade" role="dialog" aria-labelledby="viewAssertionsModalDialog"
  aria-hidden="false">
  <div class="e-modal-dialog e-modal-dialog-centered" role="document" cdkDrag cdkDragBoundary=".modal">
    <div [className]="isMinimizeState ? 'e-modal-content' : 'e-modal-content e-modal-content-maximize'">
      <div class="e-modal-header" cdkDragHandle>
        <h1 class="e-modal-title" [matTooltip]="dialogTitle" matTooltipClass="e-tooltip e-tab-tooltip">
          {{ dialogTitle }}
        </h1>
        <button type="button" class="e-maximize" (click)="this.restoreState()">
          @if (isMinimizeState) {
          <span class="fal fa-square" title="maximize"></span>
          }
          @if (!isMinimizeState) {
          <span class="fal fa-window-restore" title="minimize"></span>
          }
        </button>
        <button type="button" class="e-close" data-dismiss="modal" aria-label="Close" (click)="onClose()">
          <span class="fal fa-times" title="Close"></span>
        </button>
      </div>
      <div class="e-modal-body">
        <div class="e-grid-wrap">
          <ag-grid-angular
            id="e-assertions-grid"
            class="ag-theme-alpine assertions-grid"
            rowSelection="multiple"
            [rowData]="rowData"
            [headerHeight]="gridProperties.headerHeight"
            [rowHeight]="gridProperties.rowHeight"
            [columnDefs]="columnDefs"
            [gridOptions]="gridOptions"
            (gridReady)="onGridReady($event)"
          >
          </ag-grid-angular>
        </div>
      </div>
    </div>
  </div>
</div>
